import React from "react";
import { Button } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-solid-svg-icons";

import { COMMUNICATION_CHANNELS } from "../../../../util/communication_statuses";
import { getCommunicationChannelIcon, getCommunicationChannelName } from "../../util/communication_channels";
import MainLayout from "../../layout";

import "./index.scss";

const PreferredCommunicationChannelScreen = ({ communication, settings, preferredCommChannel, onSetPreferredCommChannel, onGoToPreviousScreen, onGoToNextScreen, t }) => {
  const channels = [COMMUNICATION_CHANNELS.EMAIL];

  if (settings.has_sms) channels.push(COMMUNICATION_CHANNELS.SMS);
  if (settings.has_whats_app) channels.push(COMMUNICATION_CHANNELS.WHATSAPP);

  const content = (
    <div className="PreferredCommunicationChannelScreenContainer">
      <div className="PreferredCommunicationChannelScreen">
        <div className="PreferredCommunicationChannelScreen__Header">
          {t("cc_select_preferred_communication_channel").message || "Select Preferred Communication Channel"}
        </div>
        <div className="PreferredCommunicationChannelScreen__Content">
          {channels.map(channel => (
            <button
              key={channel}
              type="button"
              className={`preferred-channel-button ${preferredCommChannel === channel ? "preferred-channel-button--active" : ""}`}
              onClick={() => onSetPreferredCommChannel(channel)}
            >
              {getCommunicationChannelIcon(channel, "preferred-channel-icon")}
              <span>{getCommunicationChannelName(channel, t)}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  const navigationButtons = (
    <>
      <Button className="DeskCheckinNavigationLeftButton" onClick={onGoToPreviousScreen}>
        <FontAwesomeIcon icon={faArrowLeft} className="navigation-icon" />
        <span className="navigation-text">{t("cc_back").message || "BACK"}</span>
      </Button>

      <Button className="DeskCheckinNavigationRightButton" onClick={onGoToNextScreen}>
        <span className="navigation-text">{t("cc_next").message || "NEXT"}</span>
        <FontAwesomeIcon icon={faArrowRight} className="navigation-icon" />
      </Button>
    </>
  );

  return <MainLayout content={content} navigationButtons={navigationButtons} showTitle isCheckingOut={communication.is_checking_out} />;
};

export default withTranslation()(PreferredCommunicationChannelScreen);
